import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { AcompanhamentoProcessualCadastroComponent } from './acompanhamento-processual/acompanhamento-processual-cadastro.component';
import { AcompanhamentoProcessualDetalheComponent } from './acompanhamento-processual/acompanhamento-processual-detalhe.component';
import { AcompanhamentoProcessualEnvioComponent } from './acompanhamento-processual/acompanhamento-processual-envio.component';
import { AcompanhamentoProcessualPesquisaComponent } from './acompanhamento-processual/acompanhamento-processual-pesquisa.component';
import { AtualizacaoInfoRiscoCadastroComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-cadastro/atualizacao-info-risco-cadastro.component';

import { AtualizacaoInfoRiscoDetalheComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-detalhe.component';
import { AtualizacaoInfoRiscoEnvioComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-envio.component';
import { AtualizacaoInfoRiscoPesquisaComponent } from './atualizacao-informacoes-risco/atualizacao-info-risco-pesquisa.component';
import { AtualizacaoInformacoesLotePesquisaComponent } from './atualizacao-informacoes-risco/atualizacao-informacoes-lote-pesquisa.component';



import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { AcompanhamentoDeprCadastroComponent } from './acompanhamento-depr/acompanhamento-depr-cadastro/acompanhamento-depr-cadastro.component';
import { AcompanhamentoDeprPesquisaComponent } from './acompanhamento-depr/acompanhamento-depr-pesquisa/acompanhamento-depr-pesquisa.component';

const routes: Routes = [
  {
    path: 'atualizacao-informacoes/lote',
    component: AtualizacaoInformacoesLotePesquisaComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  },
  {
    path: 'atualizacao-info-risco',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: { agentes: AgenteFinanceiroResolver },
    data: { canReuse: false },
    children: [
      {
        path: '',
        redirectTo: 'pesquisa',
        pathMatch: 'full'
      },
      {
        path: 'cadastro',
        component: AtualizacaoInfoRiscoCadastroComponent
      },
      {
        path: 'pesquisa',
        pathMatch: 'full',
        component: AtualizacaoInfoRiscoPesquisaComponent,
      },
      {
        path: 'envio',
        component: AtualizacaoInfoRiscoEnvioComponent,
      },
      {
        path: ':id',
        component: AtualizacaoInfoRiscoDetalheComponent,
      },
    ]
  },


  {
    path: 'acompanhamento-processual',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: { agentes: AgenteFinanceiroResolver },
    data: { canReuse: false },

    children: [
      {
        path: '',
        redirectTo: 'pesquisa',
        pathMatch: 'full'
      },
      {
        path: 'pesquisa',
        pathMatch: 'full',
        component: AcompanhamentoProcessualPesquisaComponent,
      },
      {
        path: 'cadastro',
        component: AcompanhamentoProcessualCadastroComponent,
      },
      {
        path: 'envio',
        component: AcompanhamentoProcessualEnvioComponent,
      },
      {
        path: ':id',
        component: AcompanhamentoProcessualDetalheComponent,
      },
    ]
  },

  {
    path: 'acompanhamento-documento-depr',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: { agentes: AgenteFinanceiroResolver },
    data: { canReuse: false },

    children: [
      {
        path: '',
        redirectTo: 'pesquisa',
        pathMatch: 'full'
      },
      {
        path: 'pesquisa',
        pathMatch: 'full',
        component: AcompanhamentoDeprPesquisaComponent,
      },
      {
        path: 'cadastro',
        component: AcompanhamentoDeprCadastroComponent,
      },
      {
        path: 'detalhe/:id',
        component: AcompanhamentoDeprCadastroComponent,
      }
    ]
  },

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrestacaoInformacoesRoutingModule { }
